<!-- <ion-content *ngIf="geladen" #content class="section-content"> -->
<div *ngIf="auftragdetails?.isSchreibgeschuetztAnzeigen" class="archiv-message">Schreibgeschützt<span *ngIf="auftragdetails?.schreibschutzGrund"> – {{ auftragdetails.schreibschutzGrund }}</span></div>

<auftrag-zeiterfassung-komponente *ngIf="zeiterfassungObenAnzeigen" [auftragdetails]="auftragdetails"></auftrag-zeiterfassung-komponente>

<auftrag-regel-info [auftragdetails]="auftragdetails"></auftrag-regel-info>

<div *ngFor="let c of formularKonfiguration.komponenten">
  <div [ngSwitch]="c.name">
    <!-- Fahrzeug-Kennzeichen -->
    <fahrzeug-kennzeichen-komponente *ngSwitchCase="'Fahrzeug-Kennzeichen'" [auftragdetails]="auftragdetails" [komponente]="c"></fahrzeug-kennzeichen-komponente>

    <!-- Abholadresse -->
    <auftrag-adresse-komponente *ngSwitchCase="'Abholadresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="abholadresse"></auftrag-adresse-komponente>

    <!-- Zweite Abholstelle. Wird nur angezeigt, wenn sie vom ERP gefüllt wurde -->
    <auftrag-adresse-komponente *ngSwitchCase="'Abholadresse2'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="abholadresse2"></auftrag-adresse-komponente>

    <!-- Erzeugeradresse -->
    <auftrag-adresse-komponente *ngSwitchCase="'Erzeugeradresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="erzeugeradresse"></auftrag-adresse-komponente>

    <!-- Verwerteradresse -->
    <auftrag-adresse-komponente *ngSwitchCase="'Verwerteradresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="verwerteradresse"></auftrag-adresse-komponente>

    <!-- Befoerdereradresse -->
    <auftrag-adresse-komponente *ngSwitchCase="'Befoerdereradresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="befoerdereradresse"></auftrag-adresse-komponente>

    <!-- Barcode -->
    <auftrag-barcode-komponente *ngSwitchCase="'Barcode'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-barcode-komponente>

    <!-- Lieferung -->
    <auftrag-lieferung-komponente *ngSwitchCase="'Lieferung'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-lieferung-komponente>

    <!-- Lieferung-Details -->
    <auftrag-lieferung-details-komponente *ngSwitchCase="'Lieferung-Details'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-lieferung-details-komponente>

    <!-- Leergut -->
    <auftrag-leergut-komponente *ngSwitchCase="'Leergut'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-leergut-komponente>

    <!-- Hinweistexte -->
    <auftrag-hinweistexte-komponente *ngSwitchCase="'Hinweistexte'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-hinweistexte-komponente>

    <!-- Auftragsbilder -->
    <auftrag-bilder-komponente *ngSwitchCase="'Bilder'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder-komponente>

    <!-- Bilder (Kommissionierung) -->
    <auftrag-bilder2-komponente *ngSwitchCase="'Bilder2'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder2-komponente>

    <!-- Anmerkungen-->
    <auftrag-anmerkungen-komponente *ngSwitchCase="'Anmerkungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-anmerkungen-komponente>

    <!-- Ext. Auftragsnummer-->
    <auftrag-ext-nummer-komponente *ngSwitchCase="'Ext-Nummer'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-ext-nummer-komponente>

    <!-- Unterschrift -->
    <auftrag-unterschrift-komponente *ngSwitchCase="'Unterschrift'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-unterschrift-komponente>

    <!-- Statusmeldung -->
    <auftrag-statusmeldungen-komponente *ngSwitchCase="'Statusmeldungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-statusmeldungen-komponente>

    <!-- Checkliste -->
    <auftrag-checkliste-komponente *ngSwitchCase="'Checkliste'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-checkliste-komponente>

    <!-- Dateien -->
    <auftrag-dateien-komponente *ngSwitchCase="'Dateien'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-dateien-komponente>

    <!-- Buttons -->
    <auftrag-buttons-komponente *ngSwitchCase="'Buttons'" [auftragdetails]="auftragdetails" [komponente]="c" [nummer]="1"></auftrag-buttons-komponente>

    <!-- Buttons 2 -->
    <auftrag-buttons-komponente *ngSwitchCase="'Buttons2'" [auftragdetails]="auftragdetails" [komponente]="c" [nummer]="2"></auftrag-buttons-komponente>

    <!-- Buttons 3 -->
    <auftrag-buttons-komponente *ngSwitchCase="'Buttons3'" [auftragdetails]="auftragdetails" [komponente]="c" [nummer]="3"></auftrag-buttons-komponente>

    <!-- Zeiterfassung -->
    <auftrag-zeiterfassung-komponente *ngSwitchCase="'Zeiterfassung'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-zeiterfassung-komponente>

    <!-- Pellets einblasen für THEURL -->
    <auftrag-pellets-einblasen-komponente *ngSwitchCase="'PelletsEinblasen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-pellets-einblasen-komponente>

    <!-- <div *ngSwitchDefault class="unbekannte-komponente">
        Unbekannte Komponente: {{ c.name }}
      </div> -->
  </div>
</div>
<!-- </ion-content> -->